import TrackWrapper, { type TrackWrapperProps } from '@/common/TrackWrapper';
import Section, { SectionId, SectionName } from '~/constants/vdp/section';

export type OwnProps = Omit<TrackWrapperProps, 'event'> & {
  additionalCAs?: Record<string, any>;
  'data-nav-section'?: never;
  id?: never;
  section: Section;
};

export default function SectionViewedLogger({
  additionalCAs = {},
  children,
  section,
  threshold = 0.25,
  ...props
}: OwnProps) {
  return (
    <TrackWrapper
      element="section"
      data-nav-section={SectionId[section]}
      id={SectionId[section]}
      delay={0}
      event={{
        eventName: SectionName[section],
        customAttributes: {
          action: 'viewed',
          ...additionalCAs
        }
      }}
      threshold={threshold}
      trackOnce
      {...props}
    >
      {children}
    </TrackWrapper>
  );
}
